
import { SiteData, SiteTypes } from '@rtl/api'
import { mixins, Options, Prop } from 'vue-property-decorator'
import { RouteLocationRaw } from 'vue-router'

import TvShowHeroWidgetBlock from '../components/widget/TvShowHeroWidgetBlock.vue'
import { GetPageMixin } from '../mixins'
import { WidgetMeta } from './WidgetMixin'

export const meta: WidgetMeta = {
  label: 'Műsor hero',
  fields: {
    title: {
      type: String,
      props: {
        placeholder: 'Egyedi cím'
      }
    },
    description: {
      type: String,
      props: {
        placeholder: 'Egyedi alcím'
      }
    },
    coverUrl: {
      type: String,
      props: {
        placeholder: 'Egyedi háttérkép url'
      }
    },
    logoUrl: {
      type: String,
      props: {
        placeholder: 'Egyedi logo url'
      }
    },
    btnUrl: {
      type: String,
      props: {
        placeholder: 'CTA link (url)'
      }
    },
    btnLabel: {
      type: String,
      props: {
        placeholder: 'CTA link (szöveg)'
      }
    },
    fullBroadcasts: {
      type: Boolean,
      default: true,
      props: {
        label: 'Teljes adások'
      }
    },
    fullBroadcastsLabel: {
      type: String,
      default: 'Teljes adások',
      props: {
        placeholder: 'Teljes adások'
      }
    },
    showDetails: {
      type: Boolean,
      default: true,
      props: {
        label: 'Műsorleírás'
      }
    }
  },
  timing: false
}

@Options({
  name: 'TvShowHeroWidget',
  components: {
    TvShowHeroWidgetBlock
  }
})
export default class TvShowHeroWidget extends mixins(GetPageMixin) {
  @Prop({
    type: String
  })
  readonly title: string | undefined

  @Prop({
    type: String
  })
  readonly description: string | undefined

  @Prop({
    type: String
  })
  readonly coverUrl: string | undefined

  @Prop({
    type: String
  })
  readonly logoUrl: string | undefined

  @Prop({
    type: [String, Object]
  })
  readonly btnUrl: RouteLocationRaw | undefined

  @Prop({
    type: String
  })
  readonly btnLabel!: string

  @Prop({
    type: Boolean,
    default: true
  })
  readonly fullBroadcasts!: boolean

  @Prop({
    type: String,
    default: 'Teljes adások'
  })
  readonly fullBroadcastsLabel!: string

  @Prop({
    type: Boolean,
    default: true
  })
  readonly showDetails!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  readonly isLcp!: boolean

  get site (): SiteData | undefined {
    return this.page?.site
  }

  get isShow (): boolean {
    return this.site?.type?.toLowerCase() === SiteTypes.Show
  }

  get name (): string | null {
    return this.title ?? this.site?.name ?? null
  }

  get info () {
    return this.description || this.site?.parameters?.design?.tvshowDescriptionText
  }

  get cover (): string | null {
    if (this.coverUrl) {
      return this.coverUrl
    }

    const params = this.site?.parameters

    if (params?.design?.tvshowCoverImageUrls) {
      const imageUrls = params.design.tvshowCoverImageUrls as unknown as { 'tvshowCoverImageUrl': string }
      return imageUrls.tvshowCoverImageUrl
    }

    return null
  }

  get logo (): string | null {
    if (this.logoUrl) {
      return this.logoUrl
    }

    const params = this.site?.parameters

    if (params?.design?.tvshowImageUrls) {
      const imageUrls = params.design.tvshowImageUrls as unknown as { 'tvshowImageUrl': string }
      return imageUrls.tvshowImageUrl
    }

    return null
  }

  get menu () {
    return this.page?.menu?.contentMenu?.menuItems || []
  }

  get extraBtnLabel () {
    return this.btnLabel || this.site?.parameters?.design?.tvshowCtaText
  }

  get extraBtnUrl () {
    return this.btnUrl || this.site?.parameters?.design?.tvshowCtaLink
  }
}
